import { render, staticRenderFns } from "./GuestBox.vue?vue&type=template&id=e65a4142&scoped=true&"
import script from "./GuestBox.vue?vue&type=script&lang=js&"
export * from "./GuestBox.vue?vue&type=script&lang=js&"
import style0 from "./GuestBox.vue?vue&type=style&index=0&id=e65a4142&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e65a4142",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e65a4142')) {
      api.createRecord('e65a4142', component.options)
    } else {
      api.reload('e65a4142', component.options)
    }
    module.hot.accept("./GuestBox.vue?vue&type=template&id=e65a4142&scoped=true&", function () {
      api.rerender('e65a4142', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2zxp6WqS1Nph1/JS/comp/GuestBox.vue"
export default component.exports